let deferredPrompt = null;

export function registerSW() {
  // Capture the install prompt before it fires
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    console.log('[PWA] Install prompt captured');
  });

  // Expose install API globally for Landing page button
  window.__pwaInstall = {
    canInstall: () => !!deferredPrompt,
    trigger: async () => {
      if (!deferredPrompt) return false;
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log('[PWA] Install outcome:', outcome);
      deferredPrompt = null;
      return outcome === 'accepted';
    },
  };

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    console.log('[PWA] App installed');
  });

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((reg) => {
          console.log('[SW] Registered:', reg.scope);
          // Force check for updates on every page load
          reg.update().catch(() => {});
        })
        .catch((err) => {
          console.log('[SW] Registration failed:', err);
        });
    });
  }
}
